import { bindable, bindingMode, customElement } from "aurelia-framework";

@customElement("text-editor")
export class TextEditor {
    @bindable({ defaultBindingMode: bindingMode.twoWay })
    public content: string;
}
